import { useEffect, useRef, useState } from "react";

function CountUp({ end, duration = 1800, suffix = "", prefix = "" }) {
  const [value, setValue] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    if (!ref.current) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && !started.current) {
            started.current = true;
            const start = performance.now();
            const step = (now) => {
              const p = Math.min((now - start) / duration, 1);
              const eased = 1 - Math.pow(1 - p, 3);
              setValue(Math.floor(end * eased));
              if (p < 1) requestAnimationFrame(step);
              else setValue(end);
            };
            requestAnimationFrame(step);
          }
        });
      },
      { threshold: 0.3 }
    );
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [end, duration]);

  return (
    <span ref={ref} className="statnum">
      {prefix}{value.toLocaleString("es-MX")}{suffix}
    </span>
  );
}

const stats = [
  { value: 20, prefix: "+", suffix: "", label: "Años cubriendo México" },
  { value: 100, prefix: "+", suffix: "", label: "Proyectos realizados" },
  { value: 30, prefix: "+", suffix: "", label: "Ciudades con presencia" },
  { value: 2021, prefix: "", suffix: "", label: "Premio IFAI internacional" },
];

export default function StatsBar() {
  return (
    <section data-testid="stats-bar" className="bg-[#3D5311] py-20 md:py-24 border-y border-white/10 bg-grain text-white">
      <div className="container-tight">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-6">
          {stats.map((s, i) => (
            <div key={i} className="text-left" data-testid={`stat-${i}`}>
              <div className="font-display font-black text-accent text-5xl md:text-6xl lg:text-7xl tracking-tightest leading-none">
                <CountUp end={s.value} prefix={s.prefix} suffix={s.suffix} />
              </div>
              <div className="mt-4 h-px w-10 bg-white/30" />
              <p className="mt-4 text-white/80 font-display font-semibold uppercase tracking-widest text-xs md:text-sm">
                {s.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
